import src from "IMAGE";
export default { src, width: 1840, height: 395, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42h3JwRGAIAwAQfovEhwYjSQhog2cDI99bfLHGW8Q38RnoGGLokPp3kn1qojdO8SEo5Ul085CqZkfu947izsXxXMAAAAASUVORK5CYII="};
